export const TIME_CONSTANTS = {
  MINUTES_PER_HOUR: 60,
  HOURS_PER_DAY: 24,
  PADDING_LENGTH: 2,
  PADDING_CHAR: '0',
} as const;

export const SLIDER_CONFIG = {
  STEP: 1,
  THUMB_SIZE: 'size-4',
  TRACK_HEIGHT: 'h-2',
  MARKS_HEIGHT: 'h-[40px]',
  MARKS_LINE_HEIGHT: 'h-2',
  MARKS_LINE_WIDTH: 'w-px',
} as const;

export const TIME_MARKS_CONFIG = {
  MAX_MARKS: 8,
} as const;

export const TIME_RANGE_LABEL = {
  PREFIX: 'Tempo: ',
  SUFFIX: 'h',
} as const;
